import "~/misc/common";
import { p } from "~/misc/common";
import Cookies from "js-cookie";
import { Calendar } from '@fullcalendar/core';

export function initCalClosedPeriods(cal: Calendar) {
  p('initCalClosedPeriods');

  const calendar = cal;
  Cookies.set('launch_area_back', window.location.href, { path: '/' });

  // create button dynamically
  const btn = $('<button>', {
    class: 'btn btn-default btn-sm margin-5px',
    html: '<i class="fa fa-ban"></i> Lezárt időszakok'
  });
  $('#btnContainer').append(btn);

  const source = calendar.addEventSource({
    url: '/closed_periods.json',
    extraParams: {
      'q[launch_areas_id_eq]': $('#q_launch_area_id_eq').val()
    }
  });
  source.remove();

  let active = !(Cookies.get('cal_no_closed_periods') == 'true');

  refresh();

  btn.on('click', function (e) {
    $(this).blur();
    active = !active;
    refresh();
  });

  function refresh() {
    active ? btn.css('background-color', '#CCCCCC') : btn.css('background-color', 'white');
    active ? calendar.addEventSource(source) : source.remove();
    Cookies.set('cal_no_closed_periods', !active + '', {
      expires: 10,
      path: '/'
    });
  }
}